export default {
  mainShop: '主商城',
  monitoredShops: '账号商城',
  favorites: '收藏夹',
  skuInFavorites: '收藏商品',
};
